'use strict';

angular.module('openDataApp')
  .factory('AuthService', ['$rootScope', '$cookies', function ($rootScope, $cookies) {
    return {
      login: function (token) {
        $cookies.put('userToken', token, {path: '/', domain: '.' + (window.location.hostname.split('.').length === 2 ? window.location.hostname : window.location.hostname.replace(/^[^.]+\./g, ""))});
        $rootScope.loggedIn = true;
        return true;
      },
      loginAfterRegistration: function (token) {
        $cookies.put('userToken', token, {path: '/', domain: '.' + (window.location.hostname.split('.').length === 2 ? window.location.hostname : window.location.hostname.replace(/^[^.]+\./g, ""))});
        return true;
      },
      logout: function () {
        $cookies.remove('userToken', { domain: '.' + (window.location.hostname.split('.').length === 2 ? window.location.hostname : window.location.hostname.replace(/^[^.]+\./g, ""))});
        $rootScope.loggedIn = false;
      },
      isAuthenticated: function () {
        return $cookies.get('userToken') !== undefined;
      },
      getToken: function () {
        var token = $cookies.get('userToken');
        return (token === undefined ? "" : token);
      }
    };
  }]);
